export default __webpack_public_path__ + "assets/front/scss/editorial.05d901578ea341d4fe60a961766d0f47.css";